// useZiehtGerade.ts — läuft gerade ein Ziehen der Art `art`? (Paket A6)
//
// Leere oder zugeklappte Listen der Firmenakte stehen sonst gar nicht da und
// könnten nichts annehmen. Solange eine passende Zeile gezogen wird, zeigt die
// Karte sie als Ablagefläche.

import * as React from "react";
import { ziehMime } from "../forms/BeziehungsTabelle";
import { alleFenster } from "../windowManager/browserFenster/fensterRegister";

export function useZiehtGerade(art: string | null | undefined): boolean {
  const [zieht, setZieht] = React.useState(false);
  React.useEffect(() => {
    if (!art) return;
    const mime = ziehMime(art);
    let t: number | undefined;
    const start = (e: DragEvent) => {
      if (!Array.from(e.dataTransfer?.types ?? []).includes(mime)) return;
      // Nicht im dragstart selbst umbauen: Ändert sich das DOM noch während
      // dragstart, bricht Chromium das Ziehen sofort ab (Befund 02.10.2026).
      t = window.setTimeout(() => setZieht(true), 0);
    };
    const ende = () => {
      window.clearTimeout(t);
      setZieht(false);
    };
    alleFenster.addEventListener("dragstart", start);
    alleFenster.addEventListener("dragend", ende);
    alleFenster.addEventListener("drop", ende);
    return () => {
      alleFenster.removeEventListener("dragstart", start);
      alleFenster.removeEventListener("dragend", ende);
      alleFenster.removeEventListener("drop", ende);
      window.clearTimeout(t);
    };
  }, [art]);
  return zieht;
}
